module.exports = __webpack_public_path__ + "img/portraits_04_V.4b482e89.webp";